/**
 * What a person sends into a thread, and the title it gets (slice 1 spec §3.1).
 */
import { MAX_MESSAGE_CHARS, MAX_TITLE_CHARS } from "../turns/limits";

type Checked<T> = { ok: true; value: T } | { ok: false; hint: string };

export function validateBody(raw: unknown): Checked<string> {
  const body = typeof raw === "string" ? raw.trim() : "";
  if (!body) return { ok: false, hint: "body: say something." };
  if (body.length > MAX_MESSAGE_CHARS) {
    return { ok: false, hint: `body: at most ${MAX_MESSAGE_CHARS} characters.` };
  }
  return { ok: true, value: body };
}

export function validateTitle(raw: unknown): Checked<string> {
  const title = typeof raw === "string" ? raw.trim().replace(/\s+/g, " ") : "";
  if (!title || title.length > MAX_TITLE_CHARS) {
    return { ok: false, hint: `title: 1–${MAX_TITLE_CHARS} characters.` };
  }
  return { ok: true, value: title };
}

/**
 * The first line, whitespace collapsed, cut at a word boundary to at most 80
 * characters with "…" when cut. A single word longer than that is cut mid-word.
 */
export function threadTitle(body: string): string {
  const line = (body.split("\n").find((l) => l.trim()) ?? "").trim().replace(/\s+/g, " ");
  if (line.length <= MAX_TITLE_CHARS) return line;
  const room = line.slice(0, MAX_TITLE_CHARS - 1);
  const space = room.lastIndexOf(" ");
  return `${(space > 0 ? room.slice(0, space) : room).trimEnd()}…`;
}
